import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VideosRoutingModule } from './videos-routing.module';
import { VideoPreviewModule } from 'src/app/shared/video-preview/video-preview.module';
import { VideosComponent } from 'src/app/pages/user/videos/videos.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';


@NgModule({
  declarations: [
    VideosComponent,
  ],
  imports: [
    CommonModule,
    VideosRoutingModule,
    VideoPreviewModule,
    TranslateModule,
  ],
  exports: [
    VideosComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class VideosModule { }
